// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CoursesTaughtModuleLayout} from 'app_components/modules/campus/academic/coursesTaught'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import storeService from 'app_services/storeService'
import StatsService from 'app_services/campus/academic/statsService'
// @end

// @import types
import {IMyCourse} from 'app_types/campus/academic/myCoursesTypes'
// @end

// @ADD Component types
interface ICoursesTaughtModuleProps {}
interface ICoursesTaughtModuleState {
  currentYear: number,
  status: null | 'loading' | 'error',
  reportData: any,
  chartOptions: any
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CoursesTaughtModule extends Component<ICoursesTaughtModuleProps, ICoursesTaughtModuleState> {

  private statsService: StatsService
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICoursesTaughtModuleProps) {
    super(props)
    this.state = {
      currentYear: 0,
      reportData: null,
      chartOptions: {},
      status: 'loading'
    }

    this.i18nUtil = new I18nUtil()
    this.statsService = new StatsService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
   componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected',this.fetchCoursesTaught)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected',this.fetchCoursesTaught)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchCoursesTaught = async (data: IMyCourse | null) => {
    this.setState({
      status: 'loading',
      reportData: null,
    })

    if (data?._id) {
      const dataResponse = await this.statsService.fetchCoursesTaught({
        courseID: data?._id,
      })

      if (dataResponse && dataResponse.report) {
        this.setState({
          currentYear: dataResponse.currentYear,
          reportData: {
            labels: dataResponse.report.labels,
            datasets: [{
              label: this.i18nUtil.getTranslate('modules.courses_taught_module.graph.label'),
              data: dataResponse.report.data,
              backgroundColor: '#005078',
            }]
          },
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                enabled: true,
                callbacks: {
                  label: (context: any) => {
                    let label = context.dataset.label || '';

                    if (label) {
                      label += ': ';
                    }
                    if (context.parsed.y !== null) {
                      label += this.i18nUtil.getTranslate('modules.courses_taught_module.graph.tooltip', {value: context.parsed.y})
                    }
                    return label;
                  }
                }
              }
            },
            scales: {
              x: {
                display: true,
                drawBorder: false
              },
              y: {
                display: true,
                drawBorder: false
              }
            }
          },
          status: null
        })
      } else {
        this.setState(({status: null}))
      }
    } else {
      this.setState(({status: null}))
    }
  }

  render() {
    return(
      <CoursesTaughtModuleLayout
        currentYear={this.state.currentYear}
        reportData={this.state.reportData}
        chartOptions={this.state.chartOptions}
        status={this.state.status}
      />
    )
  }
}

export default connect(mapStatesToProps)(CoursesTaughtModule)
